import laundriesService from "api/laundriesService";
import { useMutation } from "react-query";

const useDeleteLaundryMutation = () => {
  return useMutation(async (laundryId: number) => {
    try {
      const res = await laundriesService.deleteLaundry(laundryId)

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  }) 
}

export default useDeleteLaundryMutation